import React from "react";
import Styles from "./DetailHeader.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

const DetailHeader = ({ heading, list, handleSelect }) => {
  const navigate = useNavigate();
  return (
    <div className={`display_flex_row ${Styles.detailsContainer}`}>
      <div className="display_flex_row_gap_8_only">
        <div
          onClick={() => navigate(-1)}
          className={`display_flex_row_gap_8_only ${Styles.backButton}`}
        >
          <ArrowBackIosIcon style={{ fontSize: "14px", color: "" }} />
          <span>Back</span>
        </div>
        <div className={Styles.sectionHeading}>{heading}</div>
      </div>
      <div className={`display_flex_row_gap_8 ${Styles.filterContainer}`}>
        {list?.map((ele) => (
          <div
            className={`display_flex_row ${
              ele?.status && Styles.eleActiveButton
            }`}
          >
            {ele.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailHeader;
